import {
    createLoadingSpinner,
    LoadingSpinner,
} from '@vfde-brix/ws10/loading-spinner';
import { NO_PATTERN_BUSINESS_LOGIC } from '@vfde-brix/ws10/core';
import { startAppListening } from 'Container/App/listener';
import { selectLoading } from 'Container/App/selectors';
import { LOADING_INDICATOR_CONTAINER } from 'Container/App/constants';

/**
 * LoadingSpinner BRIX component
 */
export const mountLoadingSpinner = (): LoadingSpinner | null => {
    const loadingSpinnerContainer = document.getElementById(LOADING_INDICATOR_CONTAINER);

    const loadingSpinner = loadingSpinnerContainer && createLoadingSpinner(loadingSpinnerContainer, {
        business: NO_PATTERN_BUSINESS_LOGIC,
    });

    startAppListening({
        predicate: (_action, currentState, previousState) =>
            selectLoading(currentState) !== selectLoading(previousState),
        effect: (_action, listenerApi) => {
            const isLoading = selectLoading(listenerApi.getState());

            loadingSpinner?.toggle(isLoading);
        },
    });

    return loadingSpinner;
};
